<template>
  <div class="commission-box">
    <van-nav-bar title="结算中心" left-arrow @click-left="$router.go(-1)" />
    <div class="commission-header">
      <div class="label">可提现金额</div>
      <div class="money-content">
        <span class="money">{{extcredits1}}</span>
        <span class="unit">元</span>
        <van-button size="small" plain type="danger" @click="$router.push('/withdraw')">提现</van-button>
      </div>
    </div>
    <van-row class="month">
      <van-col span="12">
        <div class="label">上月预估金额</div>
        <div class="value">￥{{extcredits3}}</div>
      </van-col>
      <van-col span="12">
        <div class="label">本月预估金额</div>
        <div class="value">￥{{extcredits2}}</div>
      </van-col>
    </van-row>

    <van-row class="month">
      <van-col span="12">
        <div class="label">今日订单数</div>
        <div class="value">{{todayOrder}}笔</div>
        <div>
        </div>
      </van-col>
      <van-col span="12">
        <div class="label">今日预估收入</div>
        <div class="value">￥{{todayMoney}}</div>
      </van-col>
    </van-row>
    <van-row class="month">
      <van-col span="12">
        <div class="label">昨日订单数</div>
        <div class="value">{{yesterOrder}}笔</div>
        <div>
        </div>
      </van-col>
      <van-col span="12">
        <div class="label">昨日预估收入</div>
        <div class="value">￥{{yesterMoney}}</div>
      </van-col>
    </van-row>
    <div style="height:10px;"></div>
    <!-- 提现明细 -->
    <van-cell title="提现记录" is-link to="/withdraw/record" />
  </div>
</template>


<script>
  export default {
    data() {
      return {
        extcredits1: "",  // 可提现
        extcredits2: "",  //本月预估
        extcredits3: "", //上月预估
        todayMoney:'',
        todayOrder:'', // 今日订单
        yesterMoney:'', // 昨日预估
        yesterOrder:'', // 昨日订单
      };
    },
    created() {
      this.Post({}, "/main/commission", res => {
        if (res.states == 1) {
          this.extcredits1 = res.data.extcredits1;
          this.extcredits2 = res.data.extcredits2;
          this.extcredits3 = res.data.extcredits3;
          this.todayMoney = res.data.todayMoney;
          this.todayOrder = res.data.todayOrder;
          this.yesterMoney = res.data.yesterMoney;
          this.yesterOrder = res.data.yesterOrder;
        } else {
          this.Toast.fail(res.msg);
        }
      });
    },
    methods: {
    }
  };
</script>

<style lang="less" type="text/less" scoped>
  .commission-box{
    .commission-header{
      background: #fe3738;
      color: #ffffff;
      padding: 20px;
      font-size: 16px;
      .money-content{
        padding-top: 14px;
        display: flex;
        align-items: flex-end;
        .money{
          font-size: 24px;
        }
        .unit{
          padding-left: 4px;
          flex: 1;
        }
      }
    }
    .month{
      margin-top: 10px;
      background: #ffffff;
      text-align: center;
      padding: 10px 0;
      .label{
        padding-bottom: 6px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/mine/commission.vue